import { $createMarkNode, $isMarkNode, $wrapSelectionInMarkNode } from '@lexical/mark';
import { mergeRegister } from '@lexical/utils';
import {
  $getSelection,
  $isRangeSelection,
  LexicalEditor,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  CLICK_COMMAND,
  $setSelection,
  $isTextNode,
} from 'lexical';
import { $getAbbreviationSelectionNode, $removeNodeAbbreviation, $trimSelection } from './utils';

export const ABBREVIATION_CHANGE = createCommand<string | undefined>();

export const registerCommands = (
  editor: LexicalEditor,
  handleClick: () => void,
): () => void => {
  return mergeRegister(
    editor.registerCommand(
      ABBREVIATION_CHANGE,
      (id) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }
        const node = $getAbbreviationSelectionNode(selection);
        if (!id) {
          if (node) {
            $removeNodeAbbreviation(node);
          }

          return true;
        }
        const isBackward = selection.isBackward();
        $trimSelection(selection);
        if (node && $isMarkNode(node)) {
          const newMarkNode = $createMarkNode([id]);
          newMarkNode.append(...node.getChildren());
          node.replace(newMarkNode);
        } else {
          // Wrap content in a MarkNode
          $wrapSelectionInMarkNode(selection, isBackward, id);
        }
        const markNode = $getAbbreviationSelectionNode(selection);
        const firstTextNode = markNode?.getFirstChild();
        if ($isTextNode(firstTextNode)) {
          selection.anchor.set(firstTextNode.getKey(), 0, 'text');
          selection.focus.set(firstTextNode.getKey(), 0, 'text');
          $setSelection(selection);
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    ),
    editor.registerCommand(
      CLICK_COMMAND,
      () => {

        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }
        const node = $getAbbreviationSelectionNode(selection);
        if (node && selection.getTextContent().length === 0) {
          handleClick();
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    ),
  );
};
